// extracted by mini-css-extract-plugin
export default {"container":"uYTDo5","form":"DKVjhH"};